<template>
  <div class="flex items-center gap-x-3">
    <input
      :id="id"
      v-model="value"
      :aria-describedby="helperTextId"
      :aria-invalid="!!errorMessage"
      :class="inputClasses"
      :disabled="disabled"
      :name="name"
      :value="inputValue"
      type="radio"
    >
    <label
      :class="labelClasses"
      :for="id"
      class="font-normal"
    >
      <span
        :class="{ 'sr-only': hideLabel }"
        v-text="label"
      />
    </label>
  </div>
  <div
    v-if="showErrorMessage && errorMessage"
    class="body-sm mt-1 flex items-center gap-2 text-red"
  >
    <IconExclamationCircleFilled
      :size="20"
      aria-hidden="true"
      class="text-red"
    />
    <span v-text="errorMessage" />
  </div>
  <div
    v-if="hasSlotContent($slots.helperText)"
    :id="helperTextId"
    class="body-sm mt-1"
  >
    <slot name="helperText" />
  </div>
</template>

<script lang="ts" setup>
import { useField } from 'vee-validate'
import { IconExclamationCircleFilled } from '@tabler/icons-vue'

import '@js/utils/validators'
import { useHasSlotContent } from '@js/composables/useHasSlotContent'

defineOptions({
  name: 'BaseRadioInput',
})

const props = withDefaults(
  defineProps<{
    id: string
    name: string
    label: string
    inputValue: string
    disabled?: boolean
    required?: boolean
    hideLabel?: boolean
    helperTextId?: string
    validationRules?: string
    showErrorMessage?: boolean
    labelClasses?: string | null
    inputClasses?: string | string[] | null
  }>(),
  {
    disabled: false,
    required: false,
    helperTextId: '',
    hideLabel: false,
    inputClasses: null,
    labelClasses: null,
    validationRules: '',
    showErrorMessage: true,
  },
)

defineModel<string>({
  default: '',
})

const { hasSlotContent } = useHasSlotContent()

const { errorMessage, value } = useField(
  () => props.name,
  props.validationRules,
  {
    syncVModel: 'model',
  },
)
</script>
